"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMimeTypeFromFileExtension = exports.SupportedMimeTypes = void 0;
var SupportedMimeTypes;
(function (SupportedMimeTypes) {
    SupportedMimeTypes["PDF"] = "application/pdf";
    SupportedMimeTypes["XLS"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    SupportedMimeTypes["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    SupportedMimeTypes["TXT"] = "text/*";
})(SupportedMimeTypes = exports.SupportedMimeTypes || (exports.SupportedMimeTypes = {}));
/**
 * Get supported mimetype from a given filename OR fallback to default/provided mime type
 */
var getMimeTypeFromFileExtension = function (filename, defaultMimeType) {
    if (defaultMimeType === void 0) { defaultMimeType = SupportedMimeTypes.TXT; }
    var ext = filename.split('.').pop();
    if (!ext)
        return defaultMimeType;
    if (Object.keys(SupportedMimeTypes).includes(ext.toUpperCase())) {
        return SupportedMimeTypes[ext.toUpperCase()];
    }
    return defaultMimeType;
};
exports.getMimeTypeFromFileExtension = getMimeTypeFromFileExtension;
